import React from "react";
import { Mail, Phone, MapPin, Award, BookOpen, Heart } from "lucide-react";
import OfficeBuilding from "../../Assets/OfficeBuilding.jpeg";

function AboutThePractitioner() {
  return (
    <>
      <section className="Practitioner_Section00">
        <div className="Practitioner_SectionParent00">
          <div className="Practitioner_SectionParent01">
            <div className="Practitioner_SectionBox00">
              <p className="Practitioner_Section_Title animate-top">
                About The Practitioner
              </p>

              <h2 className="Practitioner_Section_Heading02 animate-top">
                The Wellness Destination <br />
                <span className="Practitioner_Section_Heading02Span">
                  Homeopathy, LLC
                </span>
              </h2>

              <h3 className="Practitioner_Section_Content00 animate-top">
                Suneetha Kasani, B.H.M.S., M.B.A., DiHom-IACH., CCH., RSHom(NA)
              </h3>

              <p className="Practitioner_Section_Content00 animate-top">
                Suneetha is a Board Certified Classical Homeopath (CCH) and she
                is a Registered member of North American Society of Homeopaths
                RSHom(NA) who is highly passionate about homeopathic healing,
                deals with various ailments and offer holistic treatment for
                chronic and acute conditions. She has an extensive experience in
                variety of cases with different age groups and provides
                in-person, long-distance, international consultations via Phone,
                Zoom/Whataspp.
              </p>

              <p className="Practitioner_Section_Content00 animate-top">
                In 1999, she received her Bachelors in Homeopathic Medicine and
                Surgery (BHMS) from Dr. NTR University of Health Sciences in
                India and has an MBA from Penn State University. Additionally
                she has her Diploma in Homeopathy (DiHom) from the International
                Academy of Classical Homeopathy (IACH) in Greece, and was a
                student of world-renowned classical homeopath Prof. George
                Vithoulkas. She is also a graduate of American Medical College
                of Homeopathy (AMCH) at PIHMA (Phoenix Institute of Herbal
                Medicine & Accupuncture).
              </p>

              <p className="Practitioner_Section_Content00 animate-top">
                Homeopathy works wonders when a right remedy is chosen. She
                believes in the fact that a “well taken case is half cured”; so,
                she elicits as much related information as possible in an
                extensive first interview and conducts an in-depth analysis of
                each case, to customize a similimum. Suneetha will be committed
                to be a part of your homeopathic journey, until you reach your
                destination to wellness. As per the founder, S. Hahnemann,
                homeopathy gives Rapid, Gentle and Permanent Cures and she has
                been witnessing these types of cures in an array of cases.
              </p>
            </div>
          </div>

          {/* ICON FEATURES */}
          <div className="Practitioner_Section_IconTitleContent">
            <a
              href="https://maps.app.goo.gl/FYAZRePkqeSbGR89A"
              // "https://www.google.com/maps/search/?api=1&query=The+Wellness+Destination+Homeopathy,+Suite+106-H+801+Springdale+Dr+Exton,+PA+19341"
              target="_blank"
              rel="noopener noreferrer"
              className="contact_link"
            >
              <img
                src={OfficeBuilding}
                alt="Office Building"
                className="Practitioner_Image01 animate-top"
                loading="eager" // 👈 below-the-fold image
              />
            </a>

            {/* CONTACT SECTION */}
            <div className="Practitioner_Contact_Box">
              <h2 className="Practitioner_Section_IconTitleContent_Title animate-top">
                Contact & Location
              </h2>

              {/* Location (Open in Google Maps) */}
              <p className="Practitioner_Section_IconTitleContent_Content00 animate-top">
                <MapPin className="GentleRemedies_Section_HighestIcon00" />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Suite+106-H+801+Springdale+Dr+Exton,+PA+19341"
                  // "https://maps.app.goo.gl/sRpJeYwSqsfaQBYW6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact_link"
                >
                  Suite: 106-H 801 Springdale Dr Exton, PA 19341
                </a>
              </p>

              {/* Phone (Call directly) */}
              <p className="Practitioner_Section_IconTitleContent_Content00 animate-top">
                <Phone className="GentleRemedies_Section_HighestIcon00" />
                <a href="tel:+16104127940" className="contact_link">
                  +1 (610) 412-7940
                </a>
              </p>

              {/* Email (Open mail app) */}
              <p className="Practitioner_Section_IconTitleContent_Content00 animate-top">
                <Mail className="GentleRemedies_Section_HighestIcon00" />
                <a
                  href="mailto:wellnessdestinationhomeopathy@gmail.com"
                  className="contact_link"
                >
                  wellnessdestinationhomeopathy@gmail.com
                </a>
              </p>

              <p className="Practitioner_Section_IconTitleContent_Content00 animate-top">
                Available for in-person and virtual consultations via Phone,
                Zoom, and WhatsApp.
              </p>
            </div>
            {[
              {
                icon: Award,
                title: "25+ Years Experience",
                text: "Extensive clinical experience across diverse cases.",
              },
              {
                icon: BookOpen,
                title: "Global Education",
                text: "Trained in India, USA, and Greece under leading experts.",
              },
              {
                icon: Heart,
                title: "Holistic Healing",
                text: "Personalized care for individuals and families.",
              },
            ].map((c, i) => (
              <div
                key={c.title}
                className="Practitioner_Section_IconTitleContentBox animate-top"
                style={{ transitionDelay: `${i * 0.08}s` }}
              >
                <c.icon className="Practitioner_Section_IconTitleContent_Icon animate-top" />

                <div>
                  <h3 className="Practitioner_Section_IconTitleContent_Title animate-top">
                    {c.title}
                  </h3>

                  <p className="Practitioner_Section_IconTitleContent_Content animate-top">
                    {c.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutThePractitioner;
